/** @format */

import {AvailableBusinessTariff} from 'features/tariffs/types';

import {CardData, TariffFromQuery} from '../types';
import {FIELDS_DATA} from '../constants';

// Ultra-тарифы захардкожены ниже одной карточкой, поэтому исключаем их из данных API
const ULTRA_TARIFF_KEYS = ['ultra', 'ultra_pro'];

const useCardsData = (data?: ReadonlyArray<TariffFromQuery>): CardData[] => {
  if (!data) {
    return [];
  }

  // Фильтруем ultra-тарифы и любые ключи, которых нет в FIELDS_DATA
  // (новый тариф с бэка не должен ронять страницу на FIELDS_DATA[id].order)
  const tariffsWithoutUltra = data.filter(
    tariff => !ULTRA_TARIFF_KEYS.includes(tariff.key) && tariff.key in FIELDS_DATA,
  );

  if (tariffsWithoutUltra.length === 0) {
    return [];
  }

  // Находим тариф с максимальным spentMax для определения минимумов Ultra
  const maxTariff = tariffsWithoutUltra.reduce(
    (max, tariff) => ((tariff.spentMax ?? 0) > (max.spentMax ?? 0) ? tariff : max),
    tariffsWithoutUltra[0],
  );

  const mappedData = tariffsWithoutUltra.map(tariff => {
    // todo Избавиться от кастования, когда ключи будут типизированы на бэке
    const id = tariff.key as AvailableBusinessTariff;
    return {
      id,
      prices: tariff.prices || [],
      order: FIELDS_DATA[id].order,
      description: FIELDS_DATA[id].description,
      maxSubAccounts: tariff.maxSubAccounts ?? 25,
      spentMin: tariff.spentMin ?? null,
      spentMax: tariff.spentMax ?? null,
      isUltra: false,
    };
  });

  const sortedData = mappedData.toSorted((a, b) => a.order - b.order);

  // Захардкоженный Ultra с минимумами на основе максимального тарифа
  const ultraCard: CardData = {
    id: 'ultra',
    prices: [], // Пустой массив = "Цена по запросу"
    order: 999,
    description: FIELDS_DATA.ultra.description,
    maxSubAccounts: maxTariff.maxSubAccounts ?? 25,
    spentMin: null,
    spentMax: maxTariff.spentMax ?? null,
    isUltra: true,
  };

  return [...sortedData, ultraCard];
};

export {useCardsData};
